import l10n from '../i18n/I18N'
import { InfoSection } from '../InfoSection'
import { tokenizer } from '../../services/utils'
import { config } from '../Init/Init'

import classes from './styles/cryptoPackageModalHeader.module.scss'

export const CryptoPackageModalHeader = () => {
  return (
    <>
      <div className={classes.cryptoPackageModalHeader_title}>{l10n.t['cryptopackage.header']}</div>
      <div className={classes.cryptoPackageModalHeader_bundles}>{l10n.t['cryptopackage.bundles.label']}</div>
      <div className={classes.cryptoPackageModalHeader_bundlesDescription}>
        {l10n.t['cryptopackage.bundles.description']}
      </div>
      <InfoSection>
        {tokenizer(l10n.t['cryptopackage.purchase.notification'], {
          '{usdAmount}': config.minimumUSDAmountToPurchase
        })}
      </InfoSection>
    </>
  )
}
